module.exports = __webpack_public_path__ + "static/preferred-route-223002ebbdbc8d6c6268995f31f86957.jpg";